import React from "react";
import Box from "react-raster";
import styled from "styled-components";
import Container from "../Container";
import { Eyebrow, H2, Copy } from "../Typography";

const FullWidthWrapper = styled.div`
  width: 100%;
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? "60px" : "20px"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
`;

function FullWidth({
  eyebrow,
  title,
  description,
  hideTitle,
  hasBottomMargin,
  hasTopMargin,
}) {
  return (
    <FullWidthWrapper
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
    >
      <Container paddingRight={"30px"} paddingLeft={"30px"}>
        <Box cols={[12]} marginLeft={[0]} marginRight={[0]}>
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          {title && !hideTitle && <H2>{title}</H2>}
          {description && <Copy>{description}</Copy>}
        </Box>
      </Container>
    </FullWidthWrapper>
  );
}

export default FullWidth;
